var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Publishable } from '../Publishable';
import dayjs from 'dayjs';
import dashboard from '../../../API/DashboardAPI';
var DashboardSalesCampaign = /** @class */ (function (_super) {
    __extends(DashboardSalesCampaign, _super);
    function DashboardSalesCampaign() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DashboardSalesCampaign.prototype.canPublish = function () {
        return this.getCannotPublishReasons().length < 1;
    };
    DashboardSalesCampaign.prototype.getEmptyFields = function () {
        var missingItems = [];
        if (this.name.length < 1) {
            missingItems.push({ title: "Sales Campaign Name" });
        }
        if (this.startDate == null) {
            missingItems.push({ title: "Start Date" });
        }
        if (this.endDate == null) {
            missingItems.push({ title: "End Date" });
        }
        if (this.startDate && this.endDate && this.startDate.valueOf() > this.endDate.valueOf()) {
            missingItems.push({ title: "End Date is before Start Date" });
        }
        return missingItems;
    };
    DashboardSalesCampaign.prototype.getCannotPublishReasons = function () {
        var missingItems = [];
        var emptyFields = this.getEmptyFields();
        if (emptyFields && emptyFields.length > 0) {
            missingItems.push({
                title: "Missing Sales Information",
                description: "All the following fields must be filled in before you can publish this product",
                subItems: emptyFields
            });
        }
        return missingItems;
    };
    DashboardSalesCampaign.prototype.copyFromOriginal = function () {
        _super.prototype.copyFromOriginal.call(this);
        var item = this.getOriginal();
        this.name = item.name;
        this.startDate = item.startDate;
        this.endDate = item.endDate;
        this.description = item.description;
        this.salesProducts = item.salesProducts;
        this.includedSeries = item.includedSeries;
    };
    DashboardSalesCampaign.prototype.initialize = function (param) {
        var orig = new DashboardSalesCampaign();
        orig.status = Publishable.STATUS_NEW;
        this.original = orig;
        this.copyFromOriginal();
        this.status = Publishable.STATUS_DRAFT;
        if (param) {
            for (var update in param) {
                var key = update;
                this[key] = param[key];
            }
        }
    };
    DashboardSalesCampaign.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.id) return [3 /*break*/, 2];
                        return [4 /*yield*/, dashboard.alterSalesCampaign(this)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        if (!(this.status === Publishable.STATUS_DRAFT)) return [3 /*break*/, 4];
                        return [4 /*yield*/, dashboard.createSalesCampaign(this)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DashboardSalesCampaign.getFromApi = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dashboard.getSalesCampaign(id)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, DashboardSalesCampaign.createFromApi(result)];
                }
            });
        });
    };
    DashboardSalesCampaign.prototype.AddSeries = function (series) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.includedSeries.map(function (s) { return s.seriesId; }).includes(series.seriesId)) {
                            console.error("Tried to add series that is already included.");
                            return [2 /*return*/, this];
                        }
                        return [4 /*yield*/, dashboard.getSalesCampaignProductsForSeries(series.seriesId)];
                    case 1:
                        result = _a.sent();
                        this.includedSeries.push(series);
                        this.salesProducts = this.salesProducts.concat(result.map(function (dspd) { return DashboardSalesProduct.createFromApi(dspd); }));
                        return [2 /*return*/, this];
                }
            });
        });
    };
    DashboardSalesCampaign.getAllSalesCampaigns = function (fromIndex, count, search) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dashboard.getAllSalesCampaigns(fromIndex, count, search)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, { items: result.items.map(function (x) {
                                    return DashboardSalesCampaignShort.createFromApi(x);
                                }), fullCount: result.fullCount }];
                }
            });
        });
    };
    DashboardSalesCampaign.prototype.getOriginal = function () {
        //really should avoid this, but due to the circular nature of publishable, making it better was difficult on several levels
        return this.original ? this.original : null;
    };
    DashboardSalesCampaign.prototype.hasChanged = function () {
        var _a, _b;
        if (!_super.prototype.hasChanged.call(this)) {
            var orig = this.getOriginal();
            return (this.name !== orig.name ||
                !((_a = this.startDate) === null || _a === void 0 ? void 0 : _a.isSame(orig.startDate)) ||
                !((_b = this.endDate) === null || _b === void 0 ? void 0 : _b.isSame(orig.endDate)) ||
                this.description !== orig.description ||
                !this.areArraysEqual(this.salesProducts, orig.salesProducts) ||
                !this.areArraysEqual(this.includedSeries, orig.includedSeries));
        }
        return true;
    };
    DashboardSalesCampaign.prototype.areArraysEqual = function (arr1, arr2) {
        if (arr1 == null) {
            return arr2 == null;
        }
        if (arr2 == null) {
            return false;
        }
        if (arr1.length !== arr2.length) {
            return false;
        }
        for (var i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) {
                return false;
            }
        }
        return true;
    };
    DashboardSalesCampaign.prototype.unPublish = function () {
        return dashboard.unpublishSalesCampaign(this.id);
    };
    DashboardSalesCampaign.prototype.publish = function () {
        return dashboard.publishSalesCampaign(this.id);
    };
    DashboardSalesCampaign.prototype.toApi = function () {
        var dto = new DashboardSalesCampaignDTO();
        dto.name = this.name;
        dto.startDate = this.startDate ? (this.startDate).toISOString() : null;
        dto.endDate = this.endDate ? (this.endDate).toISOString() : null;
        dto.description = this.description;
        dto.salesProducts = this.salesProducts
            .filter(function (sp) { return sp.inCampaign && sp.discountPrice != null; })
            .map(function (sp) { return sp.toApi(); });
        dto.id = this.id;
        dto.status = this.status;
        return dto;
    };
    DashboardSalesCampaign.createFromApi = function (dto) {
        if (!dto)
            return null;
        var dsc = new DashboardSalesCampaign();
        for (var prop in dto) {
            if (dto.hasOwnProperty(prop)) {
                dsc[prop] = dto[prop];
            }
        }
        dsc.startDate = dto.startDate ? dayjs(dto.startDate + 'Z') : null;
        dsc.endDate = dto.endDate ? dayjs(dto.endDate + 'Z') : null;
        dsc.salesProducts = dto.salesProducts.map(function (x) { return DashboardSalesProduct.createFromApi(x); });
        dsc.original = dsc;
        dsc.name = dsc.name ? dsc.name : "";
        dsc.description = dsc.description ? dsc.description : "";
        return dsc;
    };
    DashboardSalesCampaign.prototype.mutate = function (newProps) {
        return Object.assign(new DashboardSalesCampaign(), this, newProps);
    };
    DashboardSalesCampaign.ValidateFromCsv = function (files) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        files.map(function (file, index) { return formData.append("file".concat(index + 1), file); });
                        return [4 /*yield*/, dashboard.ValidateDashboardSalesImport(formData)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    DashboardSalesCampaign.ValidateAndImportFromCsv = function (files) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        files.map(function (file, index) { return formData.append("file".concat(index + 1), file); });
                        return [4 /*yield*/, dashboard.ValidateAndImportDashboardSalesImport(formData)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return DashboardSalesCampaign;
}(Publishable));
export { DashboardSalesCampaign };
var DashboardSalesSeries = /** @class */ (function () {
    function DashboardSalesSeries() {
    }
    return DashboardSalesSeries;
}());
export { DashboardSalesSeries };
var DashboardSalesCampaignShort = /** @class */ (function () {
    function DashboardSalesCampaignShort() {
    }
    // toApi() {
    //     const dto= new DashboardSalesCampaignShortDTO();
    //    
    //     for (const prop in dto) {
    //         if (dto.hasOwnProperty(prop)) {
    //             dto[prop] = this[prop];
    //         }
    //     }
    //
    //     dto.startDate= this.startDate ? (this.startDate).toISOString() : null;
    //     dto.endDate= this.endDate ? (this.endDate).toISOString() : null;
    //     return dto;
    // }
    DashboardSalesCampaignShort.createFromApi = function (dto) {
        if (!dto)
            return null;
        var salesCampaignShort = new DashboardSalesCampaignShort();
        for (var prop in dto) {
            if (dto.hasOwnProperty(prop)) {
                salesCampaignShort[prop] = dto[prop];
            }
        }
        salesCampaignShort.startDate = dto.startDate ? dayjs(dto.startDate + 'Z') : null;
        salesCampaignShort.endDate = dto.endDate ? dayjs(dto.endDate + 'Z') : null;
        return salesCampaignShort;
    };
    return DashboardSalesCampaignShort;
}());
export { DashboardSalesCampaignShort };
var DashboardSalesCampaignShortDTO = /** @class */ (function () {
    function DashboardSalesCampaignShortDTO() {
    }
    return DashboardSalesCampaignShortDTO;
}());
export { DashboardSalesCampaignShortDTO };
var DashboardSalesCampaignDTO = /** @class */ (function () {
    function DashboardSalesCampaignDTO() {
    }
    return DashboardSalesCampaignDTO;
}());
export { DashboardSalesCampaignDTO };
var DashboardSalesProductDTO = /** @class */ (function () {
    function DashboardSalesProductDTO() {
    }
    return DashboardSalesProductDTO;
}());
export { DashboardSalesProductDTO };
var DashboardSalesProduct = /** @class */ (function () {
    function DashboardSalesProduct() {
    }
    //OverridenBy
    //IsOverriding
    DashboardSalesProduct.prototype.toApi = function () {
        var dto = new DashboardSalesProductDTO();
        // for (const prop in dto) {
        //     if (dto.hasOwnProperty(prop)) {
        //         dto[prop] = this[prop];
        //     }
        // }
        if (this.inCampaign && this.discountPrice == null || this.discountPrice === this.fullPrice) {
            console.error("This should not be turned into a DTO ");
            return null;
        }
        dto.id = this.id;
        dto.productId = this.productId;
        dto.name = this.name;
        dto.fullPrice = this.fullPrice;
        dto.discountPrice = this.discountPrice;
        dto.seriesId = this.seriesId;
        dto.variantId = this.variantId;
        return dto;
    };
    DashboardSalesProduct.prototype.mutate = function (newProps) {
        return Object.assign(new DashboardSalesProduct(), this, newProps);
    };
    DashboardSalesProduct.prototype.getVariantName = function () {
        return this.variantId === -1 ? "Digital" : "Print";
    };
    DashboardSalesProduct.prototype.wontBeSaved = function () {
        return this.inCampaign && (this.fullPrice == this.discountPrice || this.discountPrice == null);
    };
    DashboardSalesProduct.createFromApi = function (dto) {
        if (!dto)
            return null;
        var product = new DashboardSalesProduct();
        for (var prop in dto) {
            if (dto.hasOwnProperty(prop)) {
                product[prop] = dto[prop];
            }
        }
        product.inCampaign = dto.discountPrice !== undefined && dto.discountPrice !== null;
        return product;
    };
    return DashboardSalesProduct;
}());
export { DashboardSalesProduct };
